import { type FunctionComponent } from 'react';
import { type IconSize, Spinner, type SpinnerColor } from '@direct-frontend/components';
import { ErrorBlank } from '../../ErrorBlank';
import { type ErrorBlankProps } from '../../lib/types';

export interface ErrorBlankSpinnerProps extends Omit<ErrorBlankProps, 'header'> {
    size?: IconSize;
    color?: SpinnerColor;
}

export const ErrorBlankSpinner: FunctionComponent<ErrorBlankSpinnerProps> = ({ size = '64', color, ...props }) => (
    <ErrorBlank {...props} header={<Spinner size={size} color={color} />} />
);
